<template>
  <div
    class="ds-grid"
    data-cy="ds-grid"
  >
    <slot />
  </div>
</template>
